import React from 'react'
import { FormattedMessage as FormattedMessageIntl } from 'react-intl'

import './FormattedMessage.scss'

const FormattedMessage = ({ id, values, defaultMessage }) => {
  if (id == null || id === '') {
    return <span className="formatted-message-pre-line">{defaultMessage ?? ''}</span>
  }
  return (
    <span className="formatted-message-pre-line">
      <FormattedMessageIntl id={id} values={values} defaultMessage={defaultMessage} />
    </span>
  )
}

export default FormattedMessage
